import { render, staticRenderFns } from "./PremiumCalculator.vue?vue&type=template&id=5c2de631&"
import script from "./PremiumCalculator.vue?vue&type=script&lang=js&"
export * from "./PremiumCalculator.vue?vue&type=script&lang=js&"
import style0 from "./PremiumCalculator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports